<template>
  <section>
    <loader fill v-if="isLoading" />
    <pay v-else-if="season" :season="season" />
    <div class="error" v-else>
      <h3>🚨</h3>
      <p>This page is not available</p>
      <router-link :to="{name: 'Home'}">
        <span class="g-button">Go Home</span>
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue';
import Pay from './comic/Pay.vue';

export default {
  name: 'BuySeason',
  components: {
    Loader,
    Pay,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    ...mapActions(['fetchAllSeasons']),
  },
  created() {
    this.fetchAllSeasons().then(() => {
      this.isLoading = false;
    });
  },
  computed: {
    ...mapGetters(['getSeason']),
    season() {
      const { seasonId } = this.$route.params;
      return this.getSeason(seasonId);
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  text-align: center;
}
</style>
